import { getClasses, pxToEm } from "../utils";
import classes from "../styles/Icon.module.css";
import { ReactComponent as Info } from "../assets/icons/info.svg";
import { ReactComponent as Balance } from "../assets/icons/balance.svg";
import { ReactComponent as Stake } from "../assets/icons/stake.svg";
import { ReactComponent as SelectStake } from "../assets/icons/choose-stake.svg";
import { ReactComponent as Close } from "../assets/icons/close.svg";
import { ReactComponent as FullscreenOff } from "../assets/icons/fullscreen-off.svg";
import { ReactComponent as FullscreenOn } from "../assets/icons/fullscreen-on.svg";
import { ReactComponent as Play } from "../assets/icons/play.svg";
import { ReactComponent as Stop } from "../assets/icons/stop.svg";
import { ReactComponent as SoundOff } from "../assets/icons/sound-off.svg";
import { ReactComponent as SoundMid } from "../assets/icons/sound-mid.svg";
import { ReactComponent as SoundOn } from "../assets/icons/sound-on.svg";
import { ReactComponent as Spin } from "../assets/icons/spin.svg";
import { ReactComponent as Chevron } from "../assets/icons/chevron.svg";
import { ReactComponent as Thumb } from "../assets/icons/thumb.svg";
import { ReactComponent as Home } from "../assets/icons/home.svg";
import { ReactComponent as Lightning } from "../assets/icons/lightning.svg";
import { ReactComponent as LightningOff } from "../assets/icons/lightning-off.svg";
import { ReactComponent as Bank } from "../assets/icons/bank.svg";
import { ReactComponent as Account } from "../assets/icons/account.svg";
import { ReactComponent as BuyBonus } from "../assets/icons/buy-bonus.svg";
import { ReactComponent as BuyBonusSocial } from "../assets/icons/buy-bonus-social.svg";
import { ReactComponent as BetBoost } from "../assets/icons/bet-boost.svg";
import { ReactComponent as PlayBoost } from "../assets/icons/play-boost.svg";

const Types = {
  Info,
  Balance,
  Stake,
  SelectStake,
  Close,
  FullscreenOff,
  FullscreenOn,
  Play,
  Stop,
  SoundOff,
  SoundMid,
  SoundOn,
  Spin,
  Chevron,
  Thumb,
  Home,
  Lightning,
  LightningOff,
  Bank,
  Account,
  BuyBonus,
  BuyBonusSocial,
  BetBoost,
  PlayBoost,
};

export type IconType = keyof typeof Types;
export const isIcon = (s: string) => Object.keys(Types).includes(s);

// TODO maybe put all such interface into a "model" dir or something like that
export interface IconProps {
  type: IconType;
  size?: number;
  color?: string;
  className?: string;
  name?: string;
}

const Icon: React.FC<IconProps> = ({
  type,
  size = 50,
  color = "",
  name = Math.random().toString(),
  className,
}: IconProps) => {
  const height = pxToEm(size);
  const Icon = Types[type];

  return (
    <Icon
      key={name}
      className={getClasses(classes, className, "icon")}
      style={{ fill: color, height }}
    />
  );
};

export default Icon;
